import React from "react";
import { useIntl } from "react-intl";

// Wrapper component to provide intl context to class components
// This replaces the deprecated injectIntl HOC in react-intl v7
export function withIntl(WrappedComponent) {
  return function WithIntlWrapper(props) {
    const intl = useIntl();
    return <WrappedComponent {...props} intl={intl} />;
  };
}

export default withIntl;
